// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconBoldHeartCircle = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.00065 1.33301C4.32065 1.33301 1.33398 4.31967 1.33398 7.99967C1.33398 11.6797 4.32065 14.6663 8.00065 14.6663C11.6807 14.6663 14.6673 11.6797 14.6673 7.99967C14.6673 4.31967 11.6807 1.33301 8.00065 1.33301ZM8.22065 11.333C8.10065 11.373 7.89398 11.373 7.77398 11.333C6.73398 10.9797 4.40065 9.49301 4.40065 6.97301C4.40065 5.85967 5.29398 4.95967 6.40065 4.95967C7.05398 4.95967 7.63398 5.27301 8.00065 5.76634C8.36065 5.27967 8.94732 4.95967 9.60065 4.95967C10.7073 4.95967 11.6007 5.85967 11.6007 6.97301C11.6007 9.49301 9.26732 10.9797 8.22065 11.333Z',
      fill: 'currentColor',
    }),
  );

export { IconBoldHeartCircle };
